module.exports = __webpack_public_path__ + "img/Annuaire@2x.f406e57a.png";